import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {SuperTabsController} from "../../components/ionic2-super-tabs/src";
import {ReportService} from "../../services/report.service";
import {InfoModalPage} from "../info-modal/info-modal";

@Component({
  selector: 'page-report-customer-invoice',
  templateUrl: 'report-customer-invoice.html',
})
export class ReportCustomerInvoicePage {

  data: any;
  reportForm: FormGroup;

  expanded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public superTabsCtrl: SuperTabsController,
    public reportService: ReportService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.customers) this.data.customers = {};
    this.expanded = (this.data.customers.invoice && this.data.customers.invoice._same_as_client === 0);
    let has_data = (this.data.customers.invoice != null);
    this.reportForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.customers.invoice._requires_action : '2')),
      firstname: [(has_data ? this.data.customers.invoice.firstname : '')],
      lastname: [(has_data ? this.data.customers.invoice.lastname : '')],
      email: [(has_data ? this.data.customers.invoice.email : ''), Validators.compose([Validators.email, Validators.required])],
      phone: [(has_data ? this.data.customers.invoice.phone : '')],
      mobile: [(has_data ? this.data.customers.invoice.mobile : '')],
      street: [(has_data ? this.data.customers.invoice.street : ''), Validators.required],
      number: [(has_data ? this.data.customers.invoice.number : ''), Validators.required],
      letter: [(has_data ? this.data.customers.invoice.letter : '')],
      zipcode: [(has_data ? this.data.customers.invoice.zipcode : ''), Validators.required],
      city: [(has_data ? this.data.customers.invoice.city : ''), Validators.required],
      country: [(has_data && this.data.customers.invoice.country ? this.data.customers.invoice.country : 'NL'), Validators.required]
    });
  }

  ionViewDidEnter() {
    console.log('ReportCustomerInvoicePage: ionViewDidEnter');
    this.initForm();
  }

  ionViewDidLeave(){
    console.log('ReportCustomerInvoicePage: ionViewDidLeave');
    this.save();
  }

  isValid(){
    if(!this.expanded || this.reportForm.valid){
      return true;
    }
    return false;
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.reportForm.valid || !this.expanded){
      this.superTabsCtrl.setColor('reportCustomerInvoicePage', 'tab_ok', 'mainTabs');
      this.data._valid.reportCustomerInvoicePage = 1;
    } else {
      this.superTabsCtrl.setColor('reportCustomerInvoicePage', 'tab_error', 'mainTabs');
      this.data._valid.reportCustomerInvoicePage = -1;
    }

    if(!this.data.customers) this.data.customers = {};
    if(!this.data.customers.invoice) this.data.customers.invoice = {};
    Object.assign(this.data.customers.invoice, this.reportForm.value);
    //this.data._has_invoice_customer = (this.expanded ? 1 : 0);
    this.data.customers.invoice._same_as_client = (this.expanded ? 0 : 1);
    //this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportCustomerExternalPage', 'mainTabs');
    });
  }

  public openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-customer-invoice/report-customer-invoice.ts